import React from "react";

function formatDate(dateString) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

const BlogCard = ({ post, onSelectPost }) => {
  const {
    title = "Default Title",
    shortDescription = "Default Description",
    imageUrl = "default_image_path.jpg",
    publishDate = new Date().toISOString(),
    estimatedTimeToRead = "N/A",
  } = post || {};

  return (
    <div
      className="flex transform flex-col gap-3 rounded-lg border bg-[#F4F4F5] p-3 transition-transform hover:scale-105 cursor-pointer"
      onClick={() => onSelectPost(post)}
    >
      <figure className="relative h-40 w-full overflow-hidden bg-gray-200">
        <img
          className="absolute inset-0 h-full w-full rounded-md object-cover"
          src={imageUrl}
          alt={`Cover for ${title}`}
        />
      </figure>
      <h3 className="mb-2 text-xl font-bold text-gray-600">{title}</h3>
      <p className="text-gray-700">{shortDescription}</p>
     <p className="mt-4 text-sm font-semibold text-gray-600">
  {formatDate(
    publishDate?.seconds ? new Date(publishDate.seconds * 1000) : publishDate
  )}{" "}
  | {estimatedTimeToRead}
</p>

    </div>
  );
};


export default BlogCard;
